/* eslint-disable ember/classic-decorator-no-classic-methods, ember/no-classic-components, ember/require-tagless-components */
import { tracked } from '@glimmer/tracking';
import { action } from '@ember/object';
import Component from '@ember/component';
import { service } from '@ember/service';
import { mapBy } from '@linc-technologies/linced-common/utils/arrays';
import { loadPeople } from '@linc-technologies/linced-common/utils/load-people';
import { restartableTask } from 'ember-concurrency';

export default class ContactsPopup extends Component {
  @service
  store;

  // loadContacts loads the caregivers that the dialog shows. Opening the
  // dialog performs it. @person can be an async belongsTo, thus it is awaited.
  loadContacts = restartableTask(async () => {
    let person = await this.person;
    await loadPeople(this.store, mapBy(person.learner.contacts, 'caregiverId'));
  });

  @action
  setDialogOpen(value) {
    this.dialogOpen = value;
    if (value) {
      this.loadContacts.perform();
    }
  }

  @tracked
  dialogOpen = false;

  @action
  toggle() {
    this.toggleProperty('dialogOpen');
  }
}
